import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import { useAddDealerMutation } from "../../../features/api/dealerApi";
import { toast } from "react-toastify";

const NewDealer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [addNewDealer] = useAddDealerMutation();

  const [d_name, setName] = useState("");
  const [d_email, setEmail] = useState("");
  const [d_address, setAddress] = useState("");
  const [d_addressing, setAddressing] = useState("");
  const [d_phone, setPhone] = useState("");
  const [d_mobile, setMobile] = useState("");
  const [d_web, setWeb] = useState("");
  const handleAdd = async () => {
    if (d_name === "") {
      toast.warning("Name required...!!!");
    } else {
      try {
        const newDealer = {
          d_name,
          d_email,
          d_address,
          d_addressing,
          d_phone,
          d_mobile,
          d_web,
        };
        const result = await addNewDealer(newDealer);

        if (result) {
          setIsOpen(false);
          document.body.style.overflow = "auto";
          toast.success("Dealer create success...!!!");

          setName("");
          setEmail("");
          setAddress("");
          setPhone("");
          setMobile("");
          setWeb("");
        }
      } catch (error) {
        console.error("Error updating data:", error);
      }
    }
  };
  return (
    <div className="">
      <span
        onClick={openModal}
        className="flex items-center p-1 text-white rounded-sm bg-blue-500 font-medium text-sm cursor-pointer"
      >
        <MdAdd size={20} /> New Client
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-1 lg:p-6 rounded shadow-md m-2 lg:m-0 lg:w-[600px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Add New Client</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 overflow-auto w-full">
                    <input
                      type="text"
                      value={d_name}
                      onChange={(e) => setName(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold placeholder:font-normal"
                      placeholder="Name"
                    />
                    <input
                      type="email"
                      value={d_email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold placeholder:font-normal"
                      placeholder="Email"
                    />

                    <input
                      type="text"
                      value={d_phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold placeholder:font-normal"
                      placeholder="Phone"
                    />
                    <input
                      type="text"
                      value={d_mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold placeholder:font-normal"
                      placeholder="Mobile"
                    />
                  </div>
                  <div className="w-full mt-2">
                    <input
                      type="text"
                      value={d_web}
                      onChange={(e) => setWeb(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold w-full mb-2 placeholder:font-normal"
                      placeholder="Website"
                    />
                    <input
                      type="text"
                      value={d_address}
                      onChange={(e) => setAddress(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold w-full mb-2 placeholder:font-normal"
                      placeholder="Address"
                    />
                    <input
                      type="text"
                      value={d_addressing}
                      onChange={(e) => setAddressing(e.target.value)}
                      className="border pl-1 focus:outline-none w-full font-bold placeholder:font-normal"
                      placeholder="Addressing"
                    />
                  </div>
                  <button
                    onClick={() => handleAdd()}
                    className="bg-green-500 text-white font-bold mt-6 px-4 block m-auto"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewDealer;
